import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  findAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`artSegmented/findAll`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`artSegmented/findById`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  deleteById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`artSegmented/deleteById`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  templateImport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`artSegmented/templateImport`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  saveSegmented({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`artSegmented/saveSegmented`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getSpecialityTypeList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`artSegmented/getSpecialityTypeList`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  templateUpload({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/artSegmented/templateUpload',
        params: params,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
}
